import Router, { route } from 'preact-router';
import { useEffect, useState } from 'preact/hooks';
import { ToastContainer } from './components/Toast';
import { SEOHead } from './components/SEOHead';
import { fetchMe, user, authLoading, authChecked, isLoggedIn, isAdmin, hasActivePlan } from './stores/auth.store';
import { fetchTenantBranding, tenantBranding, tenantLoaded } from './stores/tenant.store';
import { fetchProjects, hasProjects } from './stores/project.store';
import { fetchCategories } from './stores/category.store';
import { Sidebar } from './components/Sidebar';
import { ErrorBoundary } from './components/ErrorBoundary';
import { Spinner } from './components/ui';
import { LoadingScreen } from './components/LoadingScreen';
// LoginPage removida — login agora é apenas via modal no PublicChatPage
import { AuthCallbackPage } from './pages/AuthCallback';
import { HubPage } from './pages/Hub';
import { ProjectsPage } from './pages/Projects';
import { CategoryPage } from './pages/CategoryPage';
import { ActionDetailPage } from './pages/ActionDetail';
import { AgentViewPage } from './pages/AgentView';
import { HistoryPage } from './pages/History';
import { AdminPage } from './pages/Admin';
import { RunViewPage } from './pages/RunView';
import { RunHistoryPage } from './pages/RunHistory';
import { ConnectRunnerPage } from './pages/ConnectRunner';
import { IntegrationsPage } from './pages/Integrations';
import { WorkspaceManager } from './pages/WorkspaceManager';
import { MyWorkspacesPage } from './pages/MyWorkspaces';
import { AdminClusterDashboard } from './pages/AdminClusterDashboard';
import AdminCapacityPlanning from './pages/AdminCapacityPlanning';
import { FileExplorerPage } from './pages/FileExplorer';
import { ChatPage } from './pages/Chat';
import { ChatHubPage } from './pages/ChatHubPage';
import { TopBar } from './components/TopBar';
import { MarketplacePage } from './pages/Marketplace';
// WalletPage removida — billing agora integrado no Profile
import { MyActionsPage } from './pages/MyActions';
// UserAgentsPage import removed — redirects to /agentes via CloudRedirect
// InstallElon removido — rota legada
import { RunnerV3UI } from './pages/RunnerV3UI';
import { RunnerV3List } from './pages/RunnerV3List';
import { AgentesPage } from './pages/AgentesPage';
import { EnvironmentDetailPage } from './pages/EnvironmentDetailPage';
import { RunnerV3Detail } from './pages/RunnerV3Detail';
import { AdminNotifications } from './pages/AdminNotifications';
import { AdminDocsPage } from './pages/AdminDocs';
import { AdminDockerImagesPage } from './pages/AdminDockerImages';
import { CloudAdminPage } from './pages/CloudAdmin';
import { BackupsPage } from './pages/Backups';
import { ElonRouterPage } from './pages/ElonRouter';
import { AdminCerebrosPage } from './pages/AdminCerebros';
import { AdminSkills } from './pages/AdminSkills';
import { DevModePage } from './pages/DevMode';
import { TeamsPage } from './pages/Teams';
import { ProfilePage } from './pages/Profile';
import { CopilotPage } from './pages/Copilot';
import { OpenClawDashboard } from './pages/OpenClawDashboard';
import { CRMPage } from './pages/CRM';
import { AnalyticsPage } from './pages/Analytics';
// WhatsAppConnectPage removido — rota legada
import { ReferralDashboardPage } from './pages/ReferralDashboard';
import { SubscriptionSuccessPage } from './pages/SubscriptionSuccess';
import { AdminReferralsPage } from './pages/AdminReferrals';
import { AdminSubscriptions } from './pages/AdminSubscriptions';
import { IntelligenceLayout } from './pages/intelligence/IntelligenceLayout';
import { SecurityScanPage } from './pages/SecurityScan';
import { OrchestratorPage } from './pages/Orchestrator';
import { AdminOrchestratorPage } from './pages/AdminOrchestrator';
import { AdminAgents } from './pages/AdminAgents';
import { AdminServers } from './pages/AdminServers';
import { AdminCloudServers } from './pages/AdminCloudServers';
import { AdminRunnersPage } from './pages/AdminRunners';
import { AdminFiles } from './pages/AdminFiles';
import { AdminIntegrationIcons } from './pages/AdminIntegrationIcons';
import { AdminIntegrations } from './pages/AdminIntegrations';
import { AdminUsers } from './pages/AdminUsers';
import { AdminUserDetail } from './pages/AdminUserDetail';
import { AdminCronJobs } from './pages/AdminCronJobs';
import { AdminVaultAuditPage } from './pages/AdminVaultAudit';
import { CustomerVaultPage } from './pages/CustomerVault';
import { VaultManagerPage } from './pages/VaultManager';
import { SkillsCenterPage } from './pages/SkillsCenterPage';
import { AdminUsagePage } from './pages/AdminUsage';
import { AdminSitemap } from './pages/AdminSitemap';
import { AdminDatabase } from './pages/AdminDatabase';
import { AdminSnapshots } from './pages/AdminSnapshots';
import { AdminGithub } from './pages/AdminGithub';
import { AdminFlow } from './pages/AdminFlow';
import { AdminDev } from './pages/AdminDev';
import { AdminDesignSystem } from './pages/AdminDesignSystem';
import AdminPaymentGateways from './pages/AdminPaymentGateways';
import { AdminCompliancePage } from './pages/AdminCompliance';
import { AdminLogs } from './pages/AdminLogs';
import { LLMLanding } from './pages/LLMLanding';
import { PublicChatPage } from './pages/PublicChatPage';
import { UpgradePage } from './pages/UpgradePage';
import { BugReportPage } from './pages/BugReport';
import { K8sTerminalPage } from './pages/K8sTerminal';
import { AdminBugReportsPage } from './pages/AdminBugReports';
import { AdminI18n } from './pages/AdminI18n';
import { AdminSEO } from './pages/AdminSEO';
import { AdminGeoModal } from './pages/AdminGeoModal';
import { AdminOptimizer } from './pages/AdminOptimizer';
import { AdminStripeConnect } from './pages/AdminStripeConnect';
import { GeoModal } from './components/GeoModal';
// AmbientesPage removido — rota legada
import { HelpHomePage } from './pages/HelpHome';
import { HelpCollectionPage } from './pages/HelpCollection';
import { HelpArticlePage } from './pages/HelpArticle';
import { ChangelogHomePage } from './pages/ChangelogHome';
import { ChangelogEntryPage } from './pages/ChangelogEntry';
import { DevDocsHomePage } from './pages/DevDocsHome';
import { DevDocsArticlePage } from './pages/DevDocsArticle';
import { SolutionsHome } from './pages/SolutionsHome';
import { SolutionPage } from './pages/SolutionPage';
import { BlogHome } from './pages/BlogHome';
import { BlogPost } from './pages/BlogPost';
import { BlogCategoryPage } from './pages/BlogCategory';
import { IntegrationsHome } from './pages/IntegrationsHome';
import { IntegrationDetail } from './pages/IntegrationDetail';
// ApplicationsHome/ApplicationDetail removidos — consolidado em MarketplaceHome/Detail
import { MarketplaceHome } from './pages/MarketplaceHome';
import { MarketplaceDetail } from './pages/MarketplaceDetail';
import { AdminCMSPage } from './pages/AdminCMS';
import { AdminAuth } from './pages/AdminAuth';
import { AdminChatHub } from './pages/AdminChatHub';
import { AdminPromotions } from './pages/AdminPromotions';
import { AdminAffiliates } from './pages/AdminAffiliates';
import { SuperAdminPage } from './pages/SuperAdmin';
import { AdminDomain } from './pages/AdminDomain';
import { AdminBranding } from './pages/AdminBranding';
import { AdminTeam } from './pages/AdminTeam';
import { AffiliatesPanel } from './pages/AffiliatesPanel';
import { NotificationsPage } from './pages/NotificationsPage';

function Redirect(props: { path: string; to: string }) {
  if (typeof window !== 'undefined') route(props.to);
  return null;
}

function CloudRedirect(_props: { path: string }) {
  if (typeof window !== 'undefined') window.location.href = '/agents';
  return null;
}

// HelpRedirect removido — help agora servido no domínio principal

function withAdminGuard(Component: any) {
  return function AdminGuarded(props: any) {
    if (!authChecked.value || authLoading.value) return null;
    if (!isLoggedIn.value || !isAdmin.value) {
      if (typeof window !== 'undefined') window.location.href = '/agents';
      return null;
    }
    return <Component {...props} />;
  };
}

// Wrap all admin page components with admin guard
const GuardedAdminPage = withAdminGuard(AdminPage);
const GuardedAdminNotifications = withAdminGuard(AdminNotifications);
const GuardedAdminDocsPage = withAdminGuard(AdminDocsPage);
const GuardedAdminDockerImagesPage = withAdminGuard(AdminDockerImagesPage);
const GuardedAdminOrchestratorPage = withAdminGuard(AdminOrchestratorPage);
const GuardedCloudAdminPage = withAdminGuard(CloudAdminPage);
const GuardedAdminCerebrosPage = withAdminGuard(AdminCerebrosPage);
const GuardedAdminSkills = withAdminGuard(AdminSkills);
const GuardedAdminAgents = withAdminGuard(AdminAgents);
const GuardedAdminServers = withAdminGuard(AdminServers);
const GuardedAdminCloudServers = withAdminGuard(AdminCloudServers);
const GuardedAdminSnapshots = withAdminGuard(AdminSnapshots);
const GuardedAdminRunnersPage = withAdminGuard(AdminRunnersPage);
const GuardedAdminFiles = withAdminGuard(AdminFiles);
const GuardedAdminIntegrationIcons = withAdminGuard(AdminIntegrationIcons);
const GuardedAdminIntegrations = withAdminGuard(AdminIntegrations);
const GuardedAnalyticsPage = withAdminGuard(AnalyticsPage);
const GuardedAdminUsagePage = withAdminGuard(AdminUsagePage);
const GuardedElonRouterPage = withAdminGuard(ElonRouterPage);
const GuardedAdminReferralsPage = withAdminGuard(AdminReferralsPage);
const GuardedAdminSubscriptions = withAdminGuard(AdminSubscriptions);
const GuardedSecurityScanPage = withAdminGuard(SecurityScanPage);
const GuardedAdminUsers = withAdminGuard(AdminUsers);
const GuardedAdminUserDetail = withAdminGuard(AdminUserDetail);
const GuardedAdminCronJobs = withAdminGuard(AdminCronJobs);
const GuardedAdminVaultAuditPage = withAdminGuard(AdminVaultAuditPage);
const GuardedVaultManagerPage = withAdminGuard(VaultManagerPage);
const GuardedAdminDev = withAdminGuard(AdminDev);
const GuardedAdminDesignSystem = withAdminGuard(AdminDesignSystem);
const GuardedAdminBranding = withAdminGuard(AdminBranding);
const GuardedAdminTeam = withAdminGuard(AdminTeam);
const GuardedAdminCompliancePage = withAdminGuard(AdminCompliancePage);
const GuardedAdminClusterDashboard = withAdminGuard(AdminClusterDashboard);
const GuardedAdminCapacityPlanning = withAdminGuard(AdminCapacityPlanning);
const GuardedAdminGithub = withAdminGuard(AdminGithub);
const GuardedAdminFlow = withAdminGuard(AdminFlow);
const GuardedAdminLogs = withAdminGuard(AdminLogs);
const GuardedAdminDatabase = withAdminGuard(AdminDatabase);
const GuardedAdminSitemap = withAdminGuard(AdminSitemap);
const GuardedAdminPaymentGateways = withAdminGuard(AdminPaymentGateways);
// Legacy admin pages removed in CMS Phase 4 — use AdminCMS unified page
const GuardedAdminCMS = withAdminGuard(AdminCMSPage);
const GuardedAdminAuth = withAdminGuard(AdminAuth);
const GuardedAdminChatHub = withAdminGuard(AdminChatHub);
const GuardedAdminPromotions = withAdminGuard(AdminPromotions);
const GuardedAdminAffiliates = withAdminGuard(AdminAffiliates);
import AdminLLMTestPage from './pages/AdminLLMTest';
const GuardedAdminLLMTest = withAdminGuard(AdminLLMTestPage);
const GuardedIntelligenceLayout = withAdminGuard(IntelligenceLayout);
const GuardedAdminBugReportsPage = withAdminGuard(AdminBugReportsPage);
const GuardedAdminI18n = withAdminGuard(AdminI18n);
const GuardedAdminSEO = withAdminGuard(AdminSEO);
const GuardedAdminGeoModal = withAdminGuard(AdminGeoModal);
const GuardedAdminOptimizer = withAdminGuard(AdminOptimizer);
const GuardedAdminStripeConnect = withAdminGuard(AdminStripeConnect);
const GuardedSuperAdminPage = withAdminGuard(SuperAdminPage);

export function App() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [currentPath, setCurrentPath] = useState(window.location.pathname);

  // Carregar branding do tenant (non-blocking, antes do auth)
  useEffect(() => { fetchTenantBranding(); }, []);

  useEffect(() => {
    fetchMe().then(() => {
      if (user.value) {
        fetchProjects();
        fetchCategories();
      }
    });
  }, []);

  // Detecção de código promocional + UTM params na URL (?promo=XXXX&utm_source=google&...)
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const promoCode = params.get('promo');
    if (promoCode) {
      localStorage.setItem('promo_code', promoCode.toUpperCase());
      // Capturar UTM params
      const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
      const utmData: Record<string, string> = {};
      for (const key of utmKeys) {
        const val = params.get(key);
        if (val) utmData[key] = val;
      }
      if (Object.keys(utmData).length > 0) {
        localStorage.setItem('promo_utm', JSON.stringify(utmData));
      }
      // Verificar promoção com UTM params + salvar banner pré-login
      const utmQuery = Object.entries(utmData).map(([k, v]) => `${k}=${encodeURIComponent(v)}`).join('&');
      api.get<any>(`/promotions/check?code=${promoCode.toUpperCase()}${utmQuery ? '&' + utmQuery : ''}`).then((res: any) => {
        if (res?.valid && res?.promotion) {
          const p = res.promotion;
          const timing = p.banner_timing || 'after_login';
          if ((timing === 'before_login' || timing === 'both') && p.banner_title) {
            localStorage.setItem('promo_banner', JSON.stringify({
              title: p.banner_title, message: p.banner_message,
              image_url: p.banner_image_url, bg_color: p.banner_bg_color || '#3B82F6',
            }));
          }
        }
      }).catch(() => {});
      // Limpar params da URL sem reload
      const url = new URL(window.location.href);
      url.searchParams.delete('promo');
      utmKeys.forEach(k => url.searchParams.delete(k));
      window.history.replaceState({}, '', url.pathname + url.search);
    }
  }, []);

  // Pedir permissão de notificações apenas após login
  useEffect(() => {
    if (!isLoggedIn.value) return;
    import('./utils/push-notifications').then(({ initializeNotificationsAfterLogin }) => {
      initializeNotificationsAfterLogin();
    });
  }, [isLoggedIn.value]);

  // Resgatar promoção pendente após login
  useEffect(() => {
    if (!isLoggedIn.value) return;
    const code = localStorage.getItem('promo_code');
    if (!code) return;
    // Recuperar UTM params salvos
    let utmData: Record<string, string> = {};
    try { utmData = JSON.parse(localStorage.getItem('promo_utm') || '{}'); } catch {}
    api.post('/promotions/redeem', { code, ...utmData }).then(() => {
      localStorage.removeItem('promo_code');
      localStorage.removeItem('promo_utm');
    }).catch(() => {
      localStorage.removeItem('promo_code');
      localStorage.removeItem('promo_utm');
    });
  }, [isLoggedIn.value]);

  // Escutar evento global do ChatHub pra abrir sidebar mobile
  useEffect(() => {
    const handler = () => setMobileMenuOpen(prev => !prev);
    window.addEventListener('toggle-mobile-menu', handler);
    return () => window.removeEventListener('toggle-mobile-menu', handler);
  }, []);

  // Scroll to top whenever current path changes
  useEffect(() => {
    // Immediate scroll
    window.scrollTo(0, 0);
    const main = document.querySelector('.main-content');
    if (main) main.scrollTop = 0;
    // Also scroll internal containers
    document.querySelectorAll('[style*="overflow-y: auto"], [style*="overflow: auto"]').forEach((el) => {
      if (el !== main) (el as HTMLElement).scrollTop = 0;
    });
  }, [currentPath]);

  // Track current path for bottom nav + scroll to top on route change
  const handleRoute = (e: any) => {
    setCurrentPath(e.url);
    setMobileMenuOpen(false);
    // Scroll to top on route change (both window and main-content container)
    window.scrollTo(0, 0);
    // Use requestAnimationFrame to ensure DOM is updated before scrolling
    requestAnimationFrame(() => {
      const main = document.querySelector('.main-content');
      if (main) main.scrollTop = 0;
      // Also scroll any internal scrollable containers
      document.querySelectorAll('[style*="overflow-y: auto"], [style*="overflow: auto"]').forEach((el) => {
        if (el !== main) (el as HTMLElement).scrollTop = 0;
      });
    });
  };

  // Public routes — no auth required
  if (window.location.pathname === '/llm') {
    return <LLMLanding />;
  }

  // Subdomínios removidos — todas as rotas CMS agora servidas no domínio principal com /:locale/

  // Aguardar branding do tenant carregar (evita piscar nomes/logos)
  if (!tenantLoaded.value) {
    return <div style={{ position: 'fixed', inset: 0, background: '#212121' }} />;
  }

  // During initial auth check: show blank screen (prevent login flash)
  if (!authChecked.value) {
    // Auth callback must work even during initial check (magic link flow)
    if (window.location.pathname === '/auth/callback') {
      return (
        <Router>
          <AuthCallbackPage path="/auth/callback" />
        </Router>
      );
    }
    // Blank screen matching bg color — no flash, no spinner
    return <div style={{ position: 'fixed', inset: 0, background: '#212121' }} />;
  }

  // Auth check done but still loading (e.g. re-auth after magic link)
  if (authLoading.value) {
    return <LoadingScreen />;
  }

  // Not logged in — show public chat page (estilo ChatGPT) + login
  if (!isLoggedIn.value) {
    return (
      <>
      <GeoModal />
      <Router>
        <AuthCallbackPage path="/auth/callback" />
        {/* LoginPage removida — /login redireciona pra /chat */}
        <LLMLanding path="/llm" />
        {/* Rotas explícitas por idioma — NÃO usar /:locale catch-all */}
        <PublicChatPage path="/pt-BR" locale="pt-BR" />
        <PublicChatPage path="/en-US" locale="en-US" />
        <PublicChatPage path="/es-ES" locale="es-ES" />
        <PublicChatPage path="/fr-FR" locale="fr-FR" />
        <PublicChatPage path="/de-DE" locale="de-DE" />
        {/* ===== Rotas CMS públicas com locale explícito ===== */}
        {/* Blog */}
        <BlogHome path="/pt-BR/blog" locale="pt-BR" />
        <BlogHome path="/en-US/blog" locale="en-US" />
        <BlogHome path="/es-ES/blog" locale="es-ES" />
        <BlogHome path="/fr-FR/blog" locale="fr-FR" />
        <BlogHome path="/de-DE/blog" locale="de-DE" />
        <BlogCategoryPage path="/pt-BR/blog/:categorySlug" locale="pt-BR" />
        <BlogCategoryPage path="/en-US/blog/:categorySlug" locale="en-US" />
        <BlogCategoryPage path="/es-ES/blog/:categorySlug" locale="es-ES" />
        <BlogCategoryPage path="/fr-FR/blog/:categorySlug" locale="fr-FR" />
        <BlogCategoryPage path="/de-DE/blog/:categorySlug" locale="de-DE" />
        <BlogPost path="/pt-BR/blog/:slug" locale="pt-BR" />
        <BlogPost path="/en-US/blog/:slug" locale="en-US" />
        <BlogPost path="/es-ES/blog/:slug" locale="es-ES" />
        <BlogPost path="/fr-FR/blog/:slug" locale="fr-FR" />
        <BlogPost path="/de-DE/blog/:slug" locale="de-DE" />
        {/* Changelog */}
        <ChangelogHomePage path="/pt-BR/changelog" locale="pt-BR" />
        <ChangelogHomePage path="/en-US/changelog" locale="en-US" />
        <ChangelogHomePage path="/es-ES/changelog" locale="es-ES" />
        <ChangelogHomePage path="/fr-FR/changelog" locale="fr-FR" />
        <ChangelogHomePage path="/de-DE/changelog" locale="de-DE" />
        <ChangelogEntryPage path="/pt-BR/changelog/:slug" locale="pt-BR" />
        <ChangelogEntryPage path="/en-US/changelog/:slug" locale="en-US" />
        <ChangelogEntryPage path="/es-ES/changelog/:slug" locale="es-ES" />
        <ChangelogEntryPage path="/fr-FR/changelog/:slug" locale="fr-FR" />
        <ChangelogEntryPage path="/de-DE/changelog/:slug" locale="de-DE" />
        {/* Solutions */}
        <SolutionsHome path="/pt-BR/solutions" locale="pt-BR" />
        <SolutionsHome path="/en-US/solutions" locale="en-US" />
        <SolutionsHome path="/es-ES/solutions" locale="es-ES" />
        <SolutionsHome path="/fr-FR/solutions" locale="fr-FR" />
        <SolutionsHome path="/de-DE/solutions" locale="de-DE" />
        <SolutionPage path="/pt-BR/solutions/:slug" locale="pt-BR" />
        <SolutionPage path="/en-US/solutions/:slug" locale="en-US" />
        <SolutionPage path="/es-ES/solutions/:slug" locale="es-ES" />
        <SolutionPage path="/fr-FR/solutions/:slug" locale="fr-FR" />
        <SolutionPage path="/de-DE/solutions/:slug" locale="de-DE" />
        {/* Marketplace */}
        <MarketplaceHome path="/pt-BR/marketplace" locale="pt-BR" />
        <MarketplaceHome path="/en-US/marketplace" locale="en-US" />
        <MarketplaceHome path="/es-ES/marketplace" locale="es-ES" />
        <MarketplaceHome path="/fr-FR/marketplace" locale="fr-FR" />
        <MarketplaceHome path="/de-DE/marketplace" locale="de-DE" />
        <MarketplaceDetail path="/pt-BR/marketplace/:slug" locale="pt-BR" />
        <MarketplaceDetail path="/en-US/marketplace/:slug" locale="en-US" />
        <MarketplaceDetail path="/es-ES/marketplace/:slug" locale="es-ES" />
        <MarketplaceDetail path="/fr-FR/marketplace/:slug" locale="fr-FR" />
        <MarketplaceDetail path="/de-DE/marketplace/:slug" locale="de-DE" />
        {/* Integrations */}
        <IntegrationsHome path="/pt-BR/integrations" locale="pt-BR" />
        <IntegrationsHome path="/en-US/integrations" locale="en-US" />
        <IntegrationsHome path="/es-ES/integrations" locale="es-ES" />
        <IntegrationsHome path="/fr-FR/integrations" locale="fr-FR" />
        <IntegrationsHome path="/de-DE/integrations" locale="de-DE" />
        <IntegrationDetail path="/pt-BR/integrations/:slug" locale="pt-BR" />
        <IntegrationDetail path="/en-US/integrations/:slug" locale="en-US" />
        <IntegrationDetail path="/es-ES/integrations/:slug" locale="es-ES" />
        <IntegrationDetail path="/fr-FR/integrations/:slug" locale="fr-FR" />
        <IntegrationDetail path="/de-DE/integrations/:slug" locale="de-DE" />
        {/* Docs */}
        <DevDocsHomePage path="/pt-BR/docs" locale="pt-BR" />
        <DevDocsHomePage path="/en-US/docs" locale="en-US" />
        <DevDocsHomePage path="/es-ES/docs" locale="es-ES" />
        <DevDocsHomePage path="/fr-FR/docs" locale="fr-FR" />
        <DevDocsHomePage path="/de-DE/docs" locale="de-DE" />
        <DevDocsHomePage path="/pt-BR/docs/:categorySlug" locale="pt-BR" />
        <DevDocsHomePage path="/en-US/docs/:categorySlug" locale="en-US" />
        <DevDocsHomePage path="/es-ES/docs/:categorySlug" locale="es-ES" />
        <DevDocsHomePage path="/fr-FR/docs/:categorySlug" locale="fr-FR" />
        <DevDocsHomePage path="/de-DE/docs/:categorySlug" locale="de-DE" />
        <DevDocsArticlePage path="/pt-BR/docs/:categorySlug/:articleSlug" locale="pt-BR" />
        <DevDocsArticlePage path="/en-US/docs/:categorySlug/:articleSlug" locale="en-US" />
        <DevDocsArticlePage path="/es-ES/docs/:categorySlug/:articleSlug" locale="es-ES" />
        <DevDocsArticlePage path="/fr-FR/docs/:categorySlug/:articleSlug" locale="fr-FR" />
        <DevDocsArticlePage path="/de-DE/docs/:categorySlug/:articleSlug" locale="de-DE" />
        {/* Help */}
        <HelpHomePage path="/pt-BR/help" locale="pt-BR" />
        <HelpHomePage path="/en-US/help" locale="en-US" />
        <HelpHomePage path="/es-ES/help" locale="es-ES" />
        <HelpHomePage path="/fr-FR/help" locale="fr-FR" />
        <HelpHomePage path="/de-DE/help" locale="de-DE" />
        <HelpCollectionPage path="/pt-BR/help/:categorySlug" locale="pt-BR" />
        <HelpCollectionPage path="/en-US/help/:categorySlug" locale="en-US" />
        <HelpCollectionPage path="/es-ES/help/:categorySlug" locale="es-ES" />
        <HelpCollectionPage path="/fr-FR/help/:categorySlug" locale="fr-FR" />
        <HelpCollectionPage path="/de-DE/help/:categorySlug" locale="de-DE" />
        <HelpArticlePage path="/pt-BR/help/:categorySlug/:articleSlug" locale="pt-BR" />
        <HelpArticlePage path="/en-US/help/:categorySlug/:articleSlug" locale="en-US" />
        <HelpArticlePage path="/es-ES/help/:categorySlug/:articleSlug" locale="es-ES" />
        <HelpArticlePage path="/fr-FR/help/:categorySlug/:articleSlug" locale="fr-FR" />
        <HelpArticlePage path="/de-DE/help/:categorySlug/:articleSlug" locale="de-DE" />
        <PublicChatPage default />
      </Router>
      </>
    );
  }

  return (
    <div class="app-layout">
      <SEOHead title={tenantBranding.value?.name || ''} description="Plataforma de agentes IA — crie, gerencie e escale seus agentes inteligentes" />
      <ToastContainer />
      <Sidebar mobileOpen={mobileMenuOpen} onClose={() => setMobileMenuOpen(false)} />
      <main class="main-content">
        <ErrorBoundary>
          <Router onChange={handleRoute}>
            <ChatHubPage path="/" />
            <HubPage path="/hub" />
            <ProjectsPage path="/projects" />
            <CategoryPage path="/categories/:slug" />
            <ActionDetailPage path="/actions/:actionId" />
            {/* AgentViewPage removed — /agents/:id now handled by EnvironmentDetailPage */}
            <HistoryPage path="/history" />
            <RunViewPage path="/runs/:runId" />
            <RunHistoryPage path="/runs" />
            <IntegrationsPage path="/integrations" />
            <GuardedAdminPage path="/admin" />
            <GuardedAdminPage path="/admin/customers" />
            <GuardedAdminPage path="/admin/wallets" />
            <GuardedAdminNotifications path="/admin/notifications" />
            <GuardedAdminDocsPage path="/admin/docs" />
            <GuardedAdminDockerImagesPage path="/admin/docker-images" />
            <ConnectRunnerPage path="/connect" />
            <MyWorkspacesPage path="/my-workspaces" />
            {/* /workspaces removido — rota legada */}
            <WorkspaceManager path="/workspace-manager/:tab?" />
            <FileExplorerPage path="/files" />
            <OrchestratorPage path="/orchestrator" />
            <GuardedAdminOrchestratorPage path="/admin/orchestrator" />
            <ChatPage path="/chat-legacy" />
            <ChatHubPage path="/chat" />
            <ChatHubPage path="/chat/:id" />
            <ChatHubPage path="/chat/agent/:agentId" />
            <MarketplacePage path="/marketplace" />
            <Redirect path="/wallet" to="/profile/wallet" />
            <MyActionsPage path="/my-actions" />
            {/* /create, /install-elon, /cloud removidos — rotas legadas */}
            <GuardedCloudAdminPage path="/admin/cloud" />
            <BackupsPage path="/backups" />
            {/* /premium removido — rota legada */}
            <CloudRedirect path="/cloud/machines/:machineId/installation-request/:requestId" />
            <CloudRedirect path="/cloud/machines/:machineId/reinstallation-request/:requestId" />
            <CloudRedirect path="/cloud/machines/:id/install" />
            <CloudRedirect path="/cloud/machines/:id" />
            <CRMPage path="/crm" />
            {/* /whatsapp-connect removido — rota legada */}
            <GuardedAdminCerebrosPage path="/admin/brain" />
            <GuardedAdminSkills path="/admin/skills" />
            <GuardedAdminAgents path="/admin/agents" />
            <GuardedAdminServers path="/admin/runners-v2" />
            <GuardedAdminCloudServers path="/admin/servers" />
            <GuardedAdminSnapshots path="/admin/snapshots" />
            <GuardedAdminRunnersPage path="/admin/runners" />
            <GuardedAdminFiles path="/admin/files" />
            <GuardedAdminIntegrationIcons path="/admin/icons" />
            <GuardedAdminIntegrations path="/admin/integrations" />
            <GuardedAnalyticsPage path="/admin/analytics" />
            <GuardedAdminUsagePage path="/admin/usage" />
            <GuardedElonRouterPage path="/admin/elon-router/:tab?" />
            <GuardedAdminLLMTest path="/admin/llm-test" />
            <GuardedElonRouterPage path="/admin/router/:tab?" />
            <DevModePage path="/dev-mode" />
            <TeamsPage path="/teams" />
            <ProfilePage path="/profile/:tab?" />
            <CopilotPage path="/copilot" />
            <ReferralDashboardPage path="/referral/:tab?" />
            <SubscriptionSuccessPage path="/subscription/success" />
            <GuardedAdminReferralsPage path="/admin/referrals" />
            <GuardedAdminSubscriptions path="/admin/subscriptions" />
            <GuardedSecurityScanPage path="/security-scan/:tab?" />
            <GuardedAdminUsers path="/admin/users" />
            <GuardedAdminUserDetail path="/admin/users/:id" />
            <GuardedAdminCronJobs path="/admin/cronjobs" />
            <GuardedAdminVaultAuditPage path="/admin/vault/audit-log" />
            <CustomerVaultPage path="/vault" />
            <GuardedVaultManagerPage path="/vault-manager" />
            <SkillsCenterPage path="/skills-center/:tab?" />
            <GuardedAdminDev path="/dev" />
            <GuardedAdminDev path="/admin/dev" />
            <GuardedAdminDesignSystem path="/admin/design" />
            <GuardedAdminCompliancePage path="/admin/compliance" />
            <GuardedAdminClusterDashboard path="/admin/cluster" />
            <GuardedAdminCapacityPlanning path="/admin/capacity-planning" />
            <GuardedAdminGithub path="/admin/github" />
            <GuardedAdminFlow path="/admin/flow" />
            <GuardedAdminLogs path="/admin/logs" />
            <GuardedAdminDatabase path="/admin/database" />
            <GuardedAdminSitemap path="/admin/sitemap" />
            {/* Legacy admin pages removed — use /admin/cms */}
            <GuardedAdminCMS path="/admin/cms" />
            <GuardedAdminAuth path="/admin/auth" />
            <GuardedAdminChatHub path="/admin/chat" />
            <GuardedAdminPromotions path="/admin/promotions" />
            <GuardedAdminAffiliates path="/admin/affiliates" />
            <AffiliatesPanel path="/affiliates" />
            <NotificationsPage path="/notifications" />
            <GuardedAdminPaymentGateways path="/admin/payment-gateways" />
            <GuardedIntelligenceLayout path="/admin/intelligence" />
            <GuardedIntelligenceLayout path="/admin/intelligence/:rest*" />
            <UpgradePage path="/upgrade" />
            <BugReportPage path="/bug-report" />
            <GuardedAdminBugReportsPage path="/admin/bug-reports" />
            <GuardedAdminI18n path="/admin/idiomas" />
            <GuardedAdminSEO path="/admin/seo" />
            <GuardedAdminGeoModal path="/admin/geo-modal" />
            <GuardedAdminOptimizer path="/admin/optimizer" />
            <GuardedAdminStripeConnect path="/admin/stripe" />
            <GuardedSuperAdminPage path="/super-admin" />
            <AdminDomain path="/admin/domain" />
            <GuardedAdminBranding path="/admin/branding" />
            <GuardedAdminTeam path="/admin/team" />
            {/* /ambientes removido — rota legada (usar /agents) */}
            <EnvironmentDetailPage path="/ambientes/:id" />
            <AgentesPage path="/agents" />
            <EnvironmentDetailPage path="/agents/:id" />
            <K8sTerminalPage path="/agents/:id/terminal" />
            {/* /agentes removido — rota legada (usar /agents) */}
            <RunnerV3Detail path="/runner-v3/:id/detail" />
            <RunnerV3UI path="/runner-v3/:id/ui" />
            {/* /login removido — login é via modal */}
            <ChatHubPage path="/dashboard" />
            {/* ===== Rotas CMS com locale explícito (5 idiomas) ===== */}
            {/* Blog */}
            <BlogHome path="/pt-BR/blog" locale="pt-BR" />
            <BlogHome path="/en-US/blog" locale="en-US" />
            <BlogHome path="/es-ES/blog" locale="es-ES" />
            <BlogHome path="/fr-FR/blog" locale="fr-FR" />
            <BlogHome path="/de-DE/blog" locale="de-DE" />
            <BlogCategoryPage path="/pt-BR/blog/:categorySlug" locale="pt-BR" />
            <BlogCategoryPage path="/en-US/blog/:categorySlug" locale="en-US" />
            <BlogCategoryPage path="/es-ES/blog/:categorySlug" locale="es-ES" />
            <BlogCategoryPage path="/fr-FR/blog/:categorySlug" locale="fr-FR" />
            <BlogCategoryPage path="/de-DE/blog/:categorySlug" locale="de-DE" />
            <BlogPost path="/pt-BR/blog/:slug" locale="pt-BR" />
            <BlogPost path="/en-US/blog/:slug" locale="en-US" />
            <BlogPost path="/es-ES/blog/:slug" locale="es-ES" />
            <BlogPost path="/fr-FR/blog/:slug" locale="fr-FR" />
            <BlogPost path="/de-DE/blog/:slug" locale="de-DE" />
            {/* Changelog */}
            <ChangelogHomePage path="/pt-BR/changelog" locale="pt-BR" />
            <ChangelogHomePage path="/en-US/changelog" locale="en-US" />
            <ChangelogHomePage path="/es-ES/changelog" locale="es-ES" />
            <ChangelogHomePage path="/fr-FR/changelog" locale="fr-FR" />
            <ChangelogHomePage path="/de-DE/changelog" locale="de-DE" />
            <ChangelogEntryPage path="/pt-BR/changelog/:slug" locale="pt-BR" />
            <ChangelogEntryPage path="/en-US/changelog/:slug" locale="en-US" />
            <ChangelogEntryPage path="/es-ES/changelog/:slug" locale="es-ES" />
            <ChangelogEntryPage path="/fr-FR/changelog/:slug" locale="fr-FR" />
            <ChangelogEntryPage path="/de-DE/changelog/:slug" locale="de-DE" />
            {/* Solutions */}
            <SolutionsHome path="/pt-BR/solutions" locale="pt-BR" />
            <SolutionsHome path="/en-US/solutions" locale="en-US" />
            <SolutionsHome path="/es-ES/solutions" locale="es-ES" />
            <SolutionsHome path="/fr-FR/solutions" locale="fr-FR" />
            <SolutionsHome path="/de-DE/solutions" locale="de-DE" />
            <SolutionPage path="/pt-BR/solutions/:slug" locale="pt-BR" />
            <SolutionPage path="/en-US/solutions/:slug" locale="en-US" />
            <SolutionPage path="/es-ES/solutions/:slug" locale="es-ES" />
            <SolutionPage path="/fr-FR/solutions/:slug" locale="fr-FR" />
            <SolutionPage path="/de-DE/solutions/:slug" locale="de-DE" />
            {/* Marketplace */}
            <MarketplaceHome path="/pt-BR/marketplace" locale="pt-BR" />
            <MarketplaceHome path="/en-US/marketplace" locale="en-US" />
            <MarketplaceHome path="/es-ES/marketplace" locale="es-ES" />
            <MarketplaceHome path="/fr-FR/marketplace" locale="fr-FR" />
            <MarketplaceHome path="/de-DE/marketplace" locale="de-DE" />
            <MarketplaceDetail path="/pt-BR/marketplace/:slug" locale="pt-BR" />
            <MarketplaceDetail path="/en-US/marketplace/:slug" locale="en-US" />
            <MarketplaceDetail path="/es-ES/marketplace/:slug" locale="es-ES" />
            <MarketplaceDetail path="/fr-FR/marketplace/:slug" locale="fr-FR" />
            <MarketplaceDetail path="/de-DE/marketplace/:slug" locale="de-DE" />
            {/* Integrations */}
            <IntegrationsHome path="/pt-BR/integrations" locale="pt-BR" />
            <IntegrationsHome path="/en-US/integrations" locale="en-US" />
            <IntegrationsHome path="/es-ES/integrations" locale="es-ES" />
            <IntegrationsHome path="/fr-FR/integrations" locale="fr-FR" />
            <IntegrationsHome path="/de-DE/integrations" locale="de-DE" />
            <IntegrationsHome path="/pt-BR/integrations/:categorySlug" locale="pt-BR" />
            <IntegrationsHome path="/en-US/integrations/:categorySlug" locale="en-US" />
            <IntegrationsHome path="/es-ES/integrations/:categorySlug" locale="es-ES" />
            <IntegrationsHome path="/fr-FR/integrations/:categorySlug" locale="fr-FR" />
            <IntegrationsHome path="/de-DE/integrations/:categorySlug" locale="de-DE" />
            <IntegrationDetail path="/pt-BR/integrations/:slug" locale="pt-BR" />
            <IntegrationDetail path="/en-US/integrations/:slug" locale="en-US" />
            <IntegrationDetail path="/es-ES/integrations/:slug" locale="es-ES" />
            <IntegrationDetail path="/fr-FR/integrations/:slug" locale="fr-FR" />
            <IntegrationDetail path="/de-DE/integrations/:slug" locale="de-DE" />
            {/* Docs (developers) */}
            <DevDocsHomePage path="/pt-BR/docs" locale="pt-BR" />
            <DevDocsHomePage path="/en-US/docs" locale="en-US" />
            <DevDocsHomePage path="/es-ES/docs" locale="es-ES" />
            <DevDocsHomePage path="/fr-FR/docs" locale="fr-FR" />
            <DevDocsHomePage path="/de-DE/docs" locale="de-DE" />
            <DevDocsHomePage path="/pt-BR/docs/:categorySlug" locale="pt-BR" />
            <DevDocsHomePage path="/en-US/docs/:categorySlug" locale="en-US" />
            <DevDocsHomePage path="/es-ES/docs/:categorySlug" locale="es-ES" />
            <DevDocsHomePage path="/fr-FR/docs/:categorySlug" locale="fr-FR" />
            <DevDocsHomePage path="/de-DE/docs/:categorySlug" locale="de-DE" />
            <DevDocsArticlePage path="/pt-BR/docs/:categorySlug/:articleSlug" locale="pt-BR" />
            <DevDocsArticlePage path="/en-US/docs/:categorySlug/:articleSlug" locale="en-US" />
            <DevDocsArticlePage path="/es-ES/docs/:categorySlug/:articleSlug" locale="es-ES" />
            <DevDocsArticlePage path="/fr-FR/docs/:categorySlug/:articleSlug" locale="fr-FR" />
            <DevDocsArticlePage path="/de-DE/docs/:categorySlug/:articleSlug" locale="de-DE" />
            {/* Help */}
            <HelpHomePage path="/pt-BR/help" locale="pt-BR" />
            <HelpHomePage path="/en-US/help" locale="en-US" />
            <HelpHomePage path="/es-ES/help" locale="es-ES" />
            <HelpHomePage path="/fr-FR/help" locale="fr-FR" />
            <HelpHomePage path="/de-DE/help" locale="de-DE" />
            <HelpCollectionPage path="/pt-BR/help/:categorySlug" locale="pt-BR" />
            <HelpCollectionPage path="/en-US/help/:categorySlug" locale="en-US" />
            <HelpCollectionPage path="/es-ES/help/:categorySlug" locale="es-ES" />
            <HelpCollectionPage path="/fr-FR/help/:categorySlug" locale="fr-FR" />
            <HelpCollectionPage path="/de-DE/help/:categorySlug" locale="de-DE" />
            <HelpArticlePage path="/pt-BR/help/:categorySlug/:articleSlug" locale="pt-BR" />
            <HelpArticlePage path="/en-US/help/:categorySlug/:articleSlug" locale="en-US" />
            <HelpArticlePage path="/es-ES/help/:categorySlug/:articleSlug" locale="es-ES" />
            <HelpArticlePage path="/fr-FR/help/:categorySlug/:articleSlug" locale="fr-FR" />
            <HelpArticlePage path="/de-DE/help/:categorySlug/:articleSlug" locale="de-DE" />
            <ChatHubPage default />
          </Router>
        </ErrorBoundary>
      </main>
      {/* TopBar unificado — mobile (todas as páginas) */}
      {window.innerWidth <= 768 && (
        <TopBar currentPath={currentPath} onHamburgerClick={() => setMobileMenuOpen(!mobileMenuOpen)} />
      )}
    </div>
  );
}
